"use client";

import Image from "next/image";
import Link from "next/link";
import ReactPaginate from "react-paginate";

import featureIcon_4 from "@/assets/images/icon/Event2.svg";
import featureIcon_1 from "@/assets/images/icon/Group5.svg";
import featureIcon_2 from "@/assets/images/icon/Gender2.svg";
import featureIcon_3 from "@/assets/images/icon/Register2.svg";
import icon from "@/assets/images/icon/icon_46.svg";
import ageGroup from "@/assets/images/icon/ageGroup2.svg";
import weight from "@/assets/images/icon/weight2.svg";

import add_to_cart_with_blue_background from "@/assets/images/logo/add_to_cart_with_blue_background..svg";
import {
  removeAndAddItems,
  selectCartItems,
} from "../../../redux/features/cartSlice";

import Loader from "@/components/Loader/Loader";
import axiosInstance from "@/service/axiosInstance";
import {
  correctUrlString,
  formatAgeForUi,
  formatDateRange,
  formatGradeForUi,
  kebabCase,
} from "@/utils/utils";
import { useParams, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  setPsaEventsCount,
  setPsaEvents,
  clearFilters,
} from "@/redux/features/psaFilterSlice";
import { setLoading } from "@/redux/features/eventSlice";
import { toast } from "react-toastify";
// import PrivateEventCard from "./PrivateEventCard";
import RemoveEventModal from "@/modals/RemoveEventModal";
import filterIcon from "@/assets/images/shape/filter.svg";
import {
  ClassificationTypes,
  CommonConstant,
  ToastOptions,
} from "@/utils/enum";
import DropdownPSA from "@/components/search-dropdown/inner-dropdown/DropdownPSA";
import { Button, Form, Modal, Spinner, Alert } from "react-bootstrap";
import { addFilter, psaFilterItems } from "@/redux/features/psaFilterSlice";
import ClearCart from "@/components/clearCart";
import BuyButton from "@/components/common/BuyButton";
import GreyboxForCard from "@/components/common/GreyboxForCard";
import { formatPrice } from "@/components/amount";
import Select from "react-select/creatable";

const ListingPsaArea = (isPsa: any) => {
  const searchParams = useParams();
  const urlParams = useSearchParams();
  const filter = useSelector(psaFilterItems);
  const title = urlParams.get("title");

  const filterRef = useRef<HTMLDivElement>(null);
  if (
    searchParams?.slug &&
    Array.isArray(searchParams.slug) &&
    searchParams.slug.length > 1
  ) {
    searchParams.second = decodeURIComponent(searchParams.slug[1]);
  }
  const itemsPerPage = 8;

  const emptyFilter = {
    eventsType: [],
    eventsMode: [],
    location: "",
    currentPage: 0,
    school: "",
    grade: "",
    age: "",
    category: "",
    gender: "",
    zoneSearchBox: "",
    eventSearchBox: "",
    title: title ?? "",
    registrationsOpen: true,
    privateEvents: false,
  };

  const dispatch = useDispatch();
  const router = useRouter();
  const cart = useSelector(selectCartItems);
  //let event = useSelector((state: any) => state.events.events);

  // const count = useSelector((state: any) => state.events.count);
  const loading = useSelector((state: any) => state.events.eventLoading);

  const [event, setEvent] = useState<any>();
  const [count, setCount] = useState(0);
  const [ENRfilter, setENRfilter] = useState<any>();
  const [currentPage, setCurrentPage] = useState(0);
  const [infoModal, setInfoModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 576);
  const [showFilter, setShowFilter] = useState(false);
  const [toggleRemoveItemsModal, setToggleRemoveItemsModal] = useState(false);
  const gradesMapping: any = useRef({});
  const itemToAdd: any = useRef(null);
  const [checkPSA, setCheckPSA] = useState<any>(false);
  const [pasEnrollmentModal, setPasEnrollmentModal] = useState(false);
  const [enrollmentNumber, setEnrollmentNumber] = useState("");
  const [showModal, setShowModal] = useState(true);
  const [formOptions, setFormOptions] = useState<any>({
    schools: [],
    grades: [],
  });
  const [childDetails, setChildDetails] = useState([]);

  const [selectedChildIds, setSelectedChildIds] = useState<
    Record<number, string>
  >({});
  const loadChildDetails = async () => {
    try {
      dispatch(setLoading(true));

      const response: any = await axiosInstance.post(
        "/load-student-details",
        {},
      );
      console.log("🚀 ~ loadChildDetails ~ response:", response);
      if (response.status == 401) {
        throw new Error("Token is not available");
      }
      if (!response) {
        throw new Error("Children data is not found");
      }
      dispatch(setLoading(false));
      setChildDetails(response);
    } catch (error: any) {
      dispatch(setLoading(false));
      console.log("Error in loading ChildDetails :>> ", error?.data || error);
    }
  };

  const handleClose = () => setShowModal(false);
  const [error, setError] = useState("");

  const highlightFilter = () => {
    if (isMobile) {
      setShowFilter(true);
    } else {
      filterRef.current?.scrollIntoView({ behavior: "smooth" });

      const handleAnimationEnd = () => {
        filterRef.current?.classList.remove("highlight-border");
        filterRef.current?.removeEventListener(
          "animationend",
          handleAnimationEnd,
        );
      };

      filterRef.current?.classList.add("highlight-border");
      filterRef.current?.addEventListener("animationend", handleAnimationEnd);
    }

    setInfoModal(false);
  };

  const handleInputChange = (e: any) => {
    setEnrollmentNumber(e.target.value);
  };

  const handleNonVibgyor = () => {
    // Handle non-Vibgyor student logic here
    // console.log("Non-Vibgyor student selected");
    handleClose();
    setPasEnrollmentModal(false);
    setInfoModal(true);
  };

  const getData = async (currentPage: any, filters: any) => {
    try {
      dispatch(setLoading(true));
      setShowFilter(false);
      if (
        filters?.school &&
        filters?.school !== "" &&
        filters?.grade &&
        filters?.grade != ""
      ) {
        const resp: any = await axiosInstance.post(
          "/events/psa/get-school-events",
          {
            venueSchool: filters?.school || filter?.schools?.value || "",
            grade: filters?.grade || filter?.grades?.value || "",
          },
        );

        if (resp.data) {
          // Group events by title
          const eventsByTitle = new Map();
          resp.data.forEach((eventdata: any) => {
            const title =
              eventdata.attributes.fees_sub_category.data.attributes.name;
            if (!eventsByTitle.has(title)) {
              eventsByTitle.set(title, []);
            }
            eventsByTitle.get(title).push(eventdata);
          });

          const pageCount = Math.ceil(event?.length / itemsPerPage);
          const offset = currentPage * itemsPerPage;
          let TotalPageEvent = Array.from(eventsByTitle.values());
          setCount(TotalPageEvent.length);
          TotalPageEvent = TotalPageEvent.slice(offset, offset + itemsPerPage);
          // const pageEvent=Array.from(eventsByTitle.values());

          setEvent(TotalPageEvent);

          dispatch(setPsaEvents(TotalPageEvent));
          setEvent(TotalPageEvent);

          if (resp?.meta?.pagination?.total) {
            dispatch(setPsaEventsCount(resp.meta.pagination.total));
          }
        } else if (resp?.events) {
          // Handle alternate response format
          const updatedEvents = resp.events.map((item: any) => ({ ...item }));
          dispatch(setPsaEvents(updatedEvents));
          setEvent(updatedEvents);

          if (resp?.meta?.pagination?.total) {
            dispatch(setPsaEventsCount(resp.meta.pagination.total));
          }
        }
      } else {
        toast.error(
          "Please select a School and Grade to view events.",
          ToastOptions,
        );
      }
    } catch (error) {
      console.log(error);
      toast.error("Unable to fetch events. Please try again.", ToastOptions);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getSchools = async () => {
    try {
      const data = await axiosInstance.get("/locations");
      if (!data.data) {
        toast.error("Unable to fetch schools. Please try again.", ToastOptions);
        return [];
      } else {
        let schoolData: any = [];
        data.data.map((doc: any) => {
          schoolData.push({
            value: doc?.attributes?.School_Name?.data?.attributes?.name,
            label: doc?.attributes?.School_Name?.data?.attributes?.name,
          });
        });

        const sortedSchoolData = schoolData.sort((a: any, b: any) => {
          const schoolA = a.value.toUpperCase();
          const schoolB = b.value.toUpperCase();

          if (schoolA < schoolB) {
            return -1;
          }
          if (schoolA > schoolB) {
            return 1;
          }
          return 0;
        });

        return sortedSchoolData;
      }
    } catch (error: any) {
      console.log("Error in getting locations :>> ", error.data || error);
      return [];
    }
  };

  const getGrades = async () => {
    try {
      const { data } = await axiosInstance.get("/grade");

      let structuredGradeData: any = [];

      for (let i = 0; i < data.length; i++) {
        structuredGradeData.push({
          label: data[i]?.attributes?.name,
          value: data[i]?.attributes?.Calculation_Value,
          order: data[i]?.attributes?.order,
        });
      }

      structuredGradeData.sort((a: any, b: any) => a.order - b.order);
      const newGradesMapping = structuredGradeData.reduce(
        (acc: any, obj: any) => {
          acc[obj.label] = obj;
          return acc;
        },
        {},
      );

      newGradesMapping["Sr. K.G."] = newGradesMapping["Sr.KG"];
      newGradesMapping["Jr. K.G."] = newGradesMapping["Jr.KG"];

      gradesMapping.current = { ...newGradesMapping };

      return structuredGradeData;
    } catch (error: any) {
      console.log("Error in loading grades :>> ", error.data || error);
      return [];
    }
  };
  const handleResetFilter = () => {
    dispatch(clearFilters());
    setENRfilter("");
    // getData(currentPage, {
    //   school: "",
    //   grade: "",
    // });
    setPasEnrollmentModal(true);
  };
  const getFormOptions = async () => {
    try {
      // Get schools and grades options
      const schools = await getSchools();
      const grades = await getGrades();

      if (schools && grades) {
        setFormOptions({ schools, grades });
      }
    } catch (error) {
      toast.error(
        "Unable to process data at the moment. Please try again later.",
        ToastOptions,
      );
    }
  };

  useEffect(() => {
    setPasEnrollmentModal(filter?.enrollmentNumber === "" && cart.length === 0);
  }, [filter?.enrollmentNumber, cart.length]);

  useEffect(() => {
    loadChildDetails();
    getFormOptions();
    // getData(currentPage, {
    //   school: filter?.schools?.value,
    //   grade: filter?.grades?.value,
    // });
  }, []);

  // const pageCount = Math.ceil(userList.length / itemsPerPage);
  // const offset = currentPage * itemsPerPage;
  // const currentPageData = userList.slice(offset, offset + itemsPerPage);

  // Handle page change
  const handlePageClick = (eventPage: any) => {
    setCurrentPage(eventPage.selected);
  };

  const onENRNoBlur = async () => {
    setLoading(true);
    setError("");
    try {
      if (!ENRfilter || ENRfilter.length === 0) {
        setError("Please enter an enrollment number");
        setLoading(false);
        return;
      }
      const public_token = process.env.NEXT_PUBLIC_API_TOKEN;
      let { data } = await axiosInstance.get(`/users/${ENRfilter}`, {
        headers: {
          "x-api-token": `Bearer ${public_token}`,
        },
      });

      if (data.Class.match(/^AS Level.*$/)) {
        // numericGrade = 11;
        data = {
          ...data,
          Class: "Grade XI",
        };
      } else if (data.Class.match(/^A Level.*$/)) {
        // numericGrade = 12;
        data = {
          ...data,
          Class: "Grade XII",
        };
      } else if (data.Class.match(/^Grade 11.*$/)) {
        // numericGrade = 12;
        data = {
          ...data,
          Class: "Grade XI",
        };
      } else if (data.Class.match(/^Grade 12.*$/)) {
        // numericGrade = 12;
        data = {
          ...data,
          Class: "Grade XII",
        };
      }
      //  else if (data.Class.match(/Grade (\d+)/)) {
      //   numericGrade = parseInt(data.Class.match(/Grade (\d+)/)[1], 10);
      // } else {
      //   numericGrade = structuredGradeData.find(
      //     (grade: any) => grade.label.replace(/[\s.]/g, "").toLowerCase() === data.Class.replace(/[\s.]/g, "").toLowerCase()
      //   )?.value;
      // }

      // Find matching school option
      const schoolOption = formOptions.schools.find(
        (school: any) => school.value === data.School,
      ) || {
        value: data.School,
        label: data.School,
      };

      // Find matching grade option
      const gradeOption = formOptions.grades.find(
        (grade: any) =>
          grade.label === data.Class || grade.value === data.Class,
      ) || {
        value: data.Class,
        label: data.Class,
      };

      // Update filter in Redux
      const updatedFilter = {
        ...filter,
        schools: schoolOption,
        grades: gradeOption,
        dob: data?.BirthDate || "",
        gender:
          data?.Gender == CommonConstant.F
            ? CommonConstant.female
            : CommonConstant.male,
        email: data?.EmailPreferred || "",
        phoneNumber: data?.MobilePreferred || data?.phone_number || "",
        studentId: data["Student ID"],
        studentType: data
          ? CommonConstant.vibgyor_student
          : CommonConstant.non_vibgyor_student,
        schoolName: data?.School || "",
        firstName: data?.Firstname || "",
        lastName: data?.Lastname || "",
        enrollmentNumber: data?.crt_enr_on || "",
      };

      // First dispatch the filter update
      dispatch(addFilter(updatedFilter));

      // Then call getData with the specific values

      // console.log("getData", data.School, data.Class, gradeOption);

      getData(currentPage, {
        school: schoolOption?.value,
        grade: gradeOption?.value,
      });

      // Close the modal
      handleClose();
      setPasEnrollmentModal(false);
      setLoading(false);
    } catch (error: any) {
      console.log(
        JSON.stringify({
          message: "Error in fetching ENR. number from database",
          errorMessage: error.message ?? error,
        }),
      );
      setError("Unable to fetch student data. Please try again.");
      toast.error(
        "Unable to fetch student data. Please try again.",
        ToastOptions,
      );
      setLoading(false);
    }
  };

  const register = (eventsArray: any, info = false) => {
    // console.log("eventsArray", eventsArray);
    if (!filter?.schools?.value || !filter?.grades?.value) {
      setInfoModal(true);
    } else {
      const prevFilter = { ...filter };
      const newFilter = {
        ...prevFilter,
        eventsType: eventsArray,
      };
      dispatch(addFilter(newFilter));
      dispatch(setPsaEvents(eventsArray));
      if (!info) {
        router.push("/psa/register");
      }
    }
  };

  const closeEventModal = () => {
    setToggleRemoveItemsModal(false);
  };

  const removePreviousEvents = () => {
    dispatch(removeAndAddItems(itemToAdd.current));
    setToggleRemoveItemsModal(false);
  };

  useEffect(() => {
    // console.log("filter.schools.value :>> ", filter?.schools?.value);
    // console.log("filter.grades.value :>> ", filter?.grades?.value);
    setENRfilter(filter?.enrollmentNumber);
    getData(currentPage, {
      school: filter?.schools?.value,
      grade: filter?.grades?.value,
    });
  }, [currentPage]);

  const handleEnrollmentChange = (e: string | undefined) => {
    if (!e || e === "other") {
      setENRfilter("");
      return;
    }
    setENRfilter(e.toUpperCase());
  };

  const childOptions = childDetails
    .map((child) => ({
      label: `${child["First Name"]} ${child["Last Name"]}`,
      value: child["Enrollment Number"],
    }))
    .concat({ label: "Other", value: "other" });
  // console.log("events ---", event);
  // console.log("filer ---", filter);

  // function groupEventsByTitle(events: any) {
  //   if (!events) { return;}
  //   const eventsByTitle = new Map();
  //   events.forEach((eventdata: any) => {
  //     const title = eventdata.attributes.title;

  //     if (!eventsByTitle.has(title)) {
  //       eventsByTitle.set(title, []);
  //     }
  //     eventsByTitle.get(title).push(eventdata);
  //   });
  //   return Array.from(eventsByTitle.values());
  // }

  // const groupevents = groupEventsByTitle(event);
  // console.log("groupevents-", groupevents);
  const fetchStudentData = async () => {
    try {
      const public_token = process.env.NEXT_PUBLIC_API_TOKEN;
      const resp: any = await axiosInstance.get(
        `/ac-student/${filter.studentId}`,
        {
          headers: {
            "x-api-token": `Bearer ${public_token}`,
          },
        },
      );

      if (resp.data.data[0]?.attributes?.crt_board_id) {
        const studentBoard = resp.data.data[0].attributes.crt_board_id;
        const school = resp.school.data[0].attributes.name;
        const grade = resp.grade.data[0].attributes.name;
        const crt_enr_on = resp.data.data[0]?.attributes?.crt_enr_on;

        // Find matching school option
        const schoolOption = formOptions.schools.find(
          (item: any) => item.label === school || item.value === school,
        ) || {
          value: school,
          label: school,
        };
        // Find matching grade option
        const gradeOption = formOptions.grades.find(
          (item: any) => item.label === grade || item.value === grade,
        ) || {
          value: grade,
          label: grade,
        };
        const updatedFilter = {
          ...filter,
          boardId: studentBoard,
          enrollmentNumber: crt_enr_on,
          schools: schoolOption,
          grades: gradeOption,
        };
        dispatch(addFilter(updatedFilter));
      }
    } catch (err) {
      toast.error("Failed to fetch the student's board.", ToastOptions);
      // router.push("/");
    }
  };

  useEffect(() => {
    if (filter?.enrollmentNumber && !filter?.boardId) {
      fetchStudentData();
    }
  }, [filter]);
  useEffect(() => {
    setCurrentPage(0);
  }, [filter?.schools?.value, filter?.grades?.value]);

  function getMinEventFeeItemId(item: any[]): string | number | undefined {
    if (!Array.isArray(item) || item.length === 0) return undefined;

    const filteredItems = item.filter(
      (e: any) => typeof e?.attributes?.event_fee === "number",
    );

    const minItem = filteredItems.reduce(
      (min: any, curr: any) =>
        curr.attributes.event_fee < min.attributes.event_fee ? curr : min,
      filteredItems[0] || item[0], // fallback to item[0] if filteredItems is empty
    );

    return minItem?.id || item[0]?.id;
  }

  return (
    <div
      className="property-listing-six bg-pink-two md-pt-0 pb-50"
      style={{ backgroundColor: "#F5F5FF" }}
    >
      {loading && <Loader />}
      <ClearCart />
      {toggleRemoveItemsModal && (
        <RemoveEventModal
          showModal={toggleRemoveItemsModal}
          closeEventModal={closeEventModal}
          removePreviousEvents={removePreviousEvents}
        />
      )}
      <div className="container container-large">
        <div className="row events-container">
          <div className="col-lg-8">
            <div className="">
              <div className="align-items-center d-sm-flex justify-content-between listing-header-filter mb-10 mt-10 mt-md-3 mt-lg-0">
                <div>
                  Showing{" "}
                  <span className="color-dark fw-500">
                    {event?.length > 0 ? currentPage * itemsPerPage + 1 : 0}
                  </span>
                  {event?.length > 0 && (
                    <>
                      <span>-</span>
                      <span className="color-dark fw-500">
                        {event?.length > 0
                          ? (currentPage + 1) * itemsPerPage
                          : 0}
                      </span>
                    </>
                  )}{" "}
                  of <span className="color-dark fw-500">{count}</span> Results
                </div>
              </div>
              {/* /----------------------------------------------------------------------------------------------------------- */}
              {event?.length > 0 ? (
                <div className="d-flex flex-wrap gx-xxl-5">
                  {/* {event} */}
                  {event?.map((item: any) => (
                    <div
                      key={item[0]?.id}
                      className="col-md-6 d-flex mb-15 wow px-2"
                    >
                      <div
                        className="listing-card-one border-25 h-100 w-100 "
                        style={{
                          border: "1px solid rgba(0, 0, 0, 0.36)",
                          borderRadius: "1rem",
                        }}
                      >
                        {/* {window.innerWidth >= 576 && ( */}
                        <div className="img-gallery p-2">
                          <div className="position-relative border-25 overflow-hidden">
                            {item[0]?.attributes?.fees_sub_type?.data.attributes
                              ?.name == "Competition" && (
                              <div
                                style={{
                                  position: "absolute",
                                  zIndex: "1",
                                  marginTop: "12px",
                                  padding: "11px 16px",
                                  gap: "10px",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  maxHeight: "32px",
                                  maxWidth: "113px",
                                  marginRight: "10px",
                                  right: 0,
                                  // borderRadius: "34px",
                                  border: "1px solid  #212121",
                                  color: "#310000",
                                  background: "#FFF",
                                }}
                              >
                                {"Competition"}
                              </div>
                            )}
                            {item[0]?.attributes?.fees_sub_type?.data.attributes
                              ?.name == "Workshop" && (
                              <div
                                style={{
                                  marginTop: "12px",
                                  position: "absolute",
                                  zIndex: "1",
                                  padding: "11px 16px",
                                  gap: "10px",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  maxHeight: "32px",

                                  marginRight: "10px",
                                  right: 0,
                                  borderRadius: "34px",
                                  border: "1px solid #3F41D1",
                                  color: "#3F41D1",
                                  background:
                                    "linear-gradient(0deg, rgba(63, 65, 209, 0.12) 0%, rgba(63, 65, 209, 0.12) 100%), #FFF",
                                }}
                              >
                                {"Workshop"}
                              </div>
                            )}
                            {item[0]?.attributes?.fees_sub_type?.data.attributes
                              ?.name == "Premier Competition" && (
                              <div
                                style={{
                                  marginTop: "12px",
                                  position: "absolute",
                                  zIndex: "1",
                                  padding: "11px 16px",
                                  gap: "10px",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  maxHeight: "32px",
                                  // maxWidth: "113px",
                                  marginRight: "3px",
                                  right: 0,
                                  borderRadius: "34px",
                                  border: "1px solid #212121",
                                  color: "#310000",
                                  background: "#FFF",
                                }}
                              >
                                {"Premier Event"}
                              </div>
                            )}
                            {/* {![
                                "Competition",
                                "Workshop",
                                "Premier Competition",
                              ].includes(
                                item[0]?.attributes?.fees_sub_type?.data
                                  .attributes?.name
                              ) && (
                                <div
                                  style={{
                                    marginTop: "12px",
                                    position: "absolute",
                                    zIndex: "1",
                                    padding: "11px 16px",
                                    gap: "10px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    maxHeight: "32px",
                                    // maxWidth: "113px",
                                    marginRight: "3px",
                                    right: 0,
                                    borderRadius: "34px",
                                    border: "1px solid #212121",
                                    color: "#310000",
                                    background: "#FFF",
                                  }}
                                >
                                  {
                                    item[0]?.attributes?.fees_sub_type?.data
                                      .attributes?.name
                                  }
                                </div>
                              )} */}
                            <div className="">
                              <div className="">
                                <Link
                                  onClick={() => register(item, true)}
                                  href={{
                                    pathname: `/event/${kebabCase(
                                      item[0]?.attributes?.zone,
                                    )}-${kebabCase(
                                      item[0]?.attributes?.school?.data
                                        ?.attributes?.name,
                                    )}-${kebabCase(
                                      item[0]?.attributes?.fees_category?.data
                                        ?.attributes?.name,
                                    )}-${kebabCase(
                                      item[0]?.attributes?.fees_sub_type?.data
                                        ?.attributes?.name,
                                    )}-${kebabCase(item[0]?.attributes?.title)}
                                    /${getMinEventFeeItemId(item)}`,
                                    // query: {
                                    //   id: item[0]?.id,
                                    // },
                                  }}
                                  className="d-block"
                                >
                                  <Image
                                    style={{
                                      maxHeight: "306px",
                                      minHeight: "185px",
                                      objectFit: "scale-down",
                                    }}
                                    src={
                                      correctUrlString(
                                        item[0]?.attributes?.image_link,
                                      )[0] ||
                                      "https://storage.googleapis.com/eduspark-prod-viva-content/VSPA%20Web%20banner/VSPA%20Webbanner.jpg"
                                    }
                                    height={300}
                                    width={500}
                                    className="w-100"
                                    alt="..."
                                  />
                                </Link>
                                {/* </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* )} */}

                        <div className="property-info px-2">
                          <div
                            style={{
                              display: "flex",
                              // minHeight: "5rem",
                              flexDirection: "column",
                              // backgroundColor: "red",
                              // gap:"5px"
                            }}
                          >
                            <div className="title tran3s">
                              <Link
                                onClick={() => register(item, true)}
                                href={{
                                  pathname: `/event/${kebabCase(
                                    item[0]?.attributes?.zone,
                                  )}-${kebabCase(
                                    item[0]?.attributes?.school?.data
                                      ?.attributes?.name,
                                  )}-${kebabCase(
                                    item[0]?.attributes?.fees_category?.data
                                      ?.attributes?.name,
                                  )}-${kebabCase(
                                    item[0]?.attributes?.fees_sub_type?.data
                                      ?.attributes?.name,
                                  )}-${kebabCase(item[0]?.attributes?.title)}
                                  /${getMinEventFeeItemId(item)}`,
                                  // query: {
                                  //   id: item[0]?.id,
                                  // },
                                }}
                                className="d-block"
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                              >
                                {
                                  item[0]?.attributes?.fees_sub_category?.data
                                    ?.attributes?.name
                                }
                              </Link>
                            </div>
                            <div style={{ display: "flex" }}>
                              <div
                                style={{
                                  fontSize: 16,
                                  color: "rgba(0, 0, 0, 0.4)",
                                }}
                              >
                                {item[0]?.attributes?.venue_name}
                              </div>

                              {/* <InfoButton InfoButtonData={"Rules Regulation"} /> */}
                            </div>
                          </div>
                          <ul className="style-none feature d-flex flex-wrap gap-0 align-items-center">
                            <li
                              className="d-flex align-items-center"
                              style={{ flex: "1 1 0" }}
                            >
                              <GreyboxForCard
                                icon={featureIcon_1}
                                label={
                                  item[0]?.attributes?.fees_category?.data
                                    ?.attributes?.name
                                }
                                value={
                                  item[0]?.attributes?.fees_category?.data
                                    ?.attributes?.name ===
                                  ClassificationTypes.Individual
                                    ? item[0]?.attributes?.minimum_entry
                                    : item[0]?.attributes?.minimum_entry +
                                      "-" +
                                      item[0]?.attributes?.maximum_entry
                                }
                              />
                            </li>

                            <li
                              className="d-flex align-items-center"
                              style={{ flex: "1 1 0" }}
                            >
                              <GreyboxForCard
                                icon={featureIcon_2}
                                label="Gender"
                                value={
                                  item[0].attributes.gender ||
                                  ClassificationTypes.All
                                }
                              />
                            </li>

                            <li
                              className="d-flex align-items-center"
                              style={{ flex: "1 1 0" }}
                            >
                              {item[0].attributes?.Is_Age_Grade === "Grade" ? (
                                (() => {
                                  // Determine grade values if applicable
                                  const from = parseInt(
                                    item[0]?.attributes?.Grade_From?.data
                                      ?.attributes?.short_name || "0",
                                    10,
                                  );
                                  const to = parseInt(
                                    item[0]?.attributes?.Grade_To?.data
                                      ?.attributes?.short_name || "0",
                                    10,
                                  );

                                  return (
                                    <GreyboxForCard
                                      icon={ageGroup}
                                      label="Grade"
                                      value={formatGradeForUi(
                                        from || 0,
                                        to || 0,
                                      )}
                                    />
                                  );
                                })()
                              ) : (
                                <GreyboxForCard
                                  icon={ageGroup}
                                  label="Age"
                                  value={formatAgeForUi(
                                    item[0]?.attributes?.age_from || 0,
                                    item[0]?.attributes?.age_to || 0,
                                  )}
                                />
                              )}
                            </li>

                            <li
                              className="d-flex align-items-center"
                              style={{ flex: "1 1 70%", minWidth: "150px" }}
                            >
                              <GreyboxForCard
                                icon={featureIcon_4}
                                label="Event dates"
                                value={formatDateRange(
                                  item[0]?.attributes?.event_start_date ||
                                    "2024-10-10",
                                  item[0]?.attributes?.event_end_date || null,
                                )}
                              />
                            </li>

                            <li
                              className="d-flex align-items-center"
                              style={{ flex: "1 1 70%", minWidth: "150px" }}
                            >
                              <GreyboxForCard
                                icon={featureIcon_3}
                                label="Registration dates"
                                value={formatDateRange(
                                  item[0]?.attributes
                                    ?.event_register_start_date || "2024-10-10",
                                  item[0]?.attributes
                                    ?.event_register_end_date || null,
                                )}
                              />
                            </li>

                            {item[0]?.attributes?.weight_from && (
                              <li
                                className="d-flex align-items-center"
                                style={{ flex: "1 1 0" }}
                              >
                                <GreyboxForCard
                                  icon={weight}
                                  label="Weight"
                                  value={`
                                    ${item[0]?.attributes?.weight_from || " "} -
                                    ${item[0]?.attributes?.weight_to || " "}
                                    `}
                                />
                              </li>
                            )}
                          </ul>

                          <div
                            className="d-flex align-items-center justify-content-between"
                            style={{
                              borderTop: "1px dashed #c7c7c7",
                              marginTop: "10px",
                              padding: "5px",
                            }}
                          >
                            <strong className="price fw-500 color-dark">
                              {" "}
                              {formatPrice(
                                Math.min(
                                  ...item.map(
                                    (items: any) =>
                                      items?.attributes?.event_fee || Infinity,
                                  ),
                                ) || 1,
                              )}
                            </strong>
                            <div
                              className="icon-container  gap-1"
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div>
                                {/* Render different elements based on item[0].inCart */}
                              </div>

                              <BuyButton
                                onButtonClick={async () => {
                                  register(item);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    height: "85vh",
                    fontSize: "1.25rem",
                    fontWeight: 500,
                  }}
                >
                  <div className="effect d-flex flex-column gap-3">
                    <div
                      className="hover-container"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        height: "10rem",
                        width: "10rem",
                        border: "2px solid gray",
                        backgroundColor: "white",
                        cursor: "pointer",
                      }}
                    >
                      <Image
                        src={add_to_cart_with_blue_background}
                        alt="Add to cart"
                        style={{ width: "6rem" }}
                      />
                    </div>
                    <div>No events found.</div>
                  </div>
                </div>
              )}
              {/* /------------------------------------------------------------------------------------------------------------ */}
              <div className="d-flex justify-content-center align-items-center">
                <ReactPaginate
                  breakLabel="..."
                  nextLabel={<Image src={icon} alt="" className="ms-2" />}
                  onPageChange={handlePageClick}
                  forcePage={currentPage}
                  pageRangeDisplayed={1}
                  pageCount={Math.ceil(count / 8)}
                  previousLabel={<Image src={icon} alt="" className="ms-2" />}
                  renderOnZeroPageCount={null}
                  className="pagination-one d-flex align-items-center justify-content-center justify-content-sm-start style-none pt-30"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 order-lg-first sm-pt-20">
            {!isMobile ? (
              <div
                className="advance-search-panel position-relative"
                style={{ marginTop: "2.9rem" }}
              >
                <div className="main-bg" ref={filterRef}>
                  <DropdownPSA
                    setCurrentPage={setCurrentPage}
                    handleResetFilter={handleResetFilter}
                    getData={getData}
                    currentPage={currentPage}
                  />
                </div>
              </div>
            ) : (
              <>
                <button
                  className="d-inline-flex align-items-center px-3 py-1 rounded-pill gap-1 my-2"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #000",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowFilter(true)}
                >
                  <Image
                    src={filterIcon}
                    alt="filterIcon"
                    className="lazy-img icon me-2"
                    style={{
                      height: "1.5rem",
                      width: "1.5rem",
                    }}
                  />
                  Filter
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* show filter in modal for mobile view */}
      {isMobile && showFilter && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            zIndex: 10,
            width: "100vw",
            height: "100vh",
            backgroundColor: "#0009",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="advance-search-panel md-mt-50 rounded-5"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              width: "90%",
              maxWidth: "650px",
              backgroundColor: "white",
              // padding: "24px",
              overflowY: "auto",
            }}
          >
            <div className="main-bg border-0">
              <DropdownPSA
                setCurrentPage={setCurrentPage}
                handleResetFilter={handleResetFilter}
                getData={getData}
                currentPage={currentPage}
                isMobile={isMobile}
                closeMobileModal={() => setShowFilter(false)}
              />
            </div>
          </div>
        </div>
      )}

      {pasEnrollmentModal && (
        <Modal
          show={pasEnrollmentModal}
          onHide={() => setPasEnrollmentModal(false)}
          centered
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title>Enter Enrollment Number</Modal.Title>
          </Modal.Header>
          {childDetails.length > 0 && (
            <div style={{ marginBottom: "10px" }} className="modal-footer">
              <Select
                options={childOptions}
                value={
                  childOptions.find(
                    (opt) => opt.value === selectedChildIds[0],
                  ) || null
                }
                onChange={(selectedOption) => {
                  const value = selectedOption?.value;
                  console.log("🚀 ~ EnrollmentModal ~ value:", value);
                  setSelectedChildIds((prev: any) => ({
                    ...prev,
                    [0]: value,
                  }));
                  setEnrollmentNumber(value || "");
                  handleEnrollmentChange(value);
                }}
                styles={{
                  container: (base) => ({
                    ...base,
                    width: "100%",
                  }),
                  menu: (base) => ({
                    ...base,
                    // maxHeight: "50vh",
                    overflowY: "auto",
                  }),
                }}
              />
            </div>
          )}
          {(childDetails.length == 0 || enrollmentNumber == "other") && (
            <Modal.Body>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  onENRNoBlur();
                }}
              >
                <Form.Group className="mb-3">
                  <Form.Label>Enrollment Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="ENXXXXXXXXX"
                    value={ENRfilter}
                    onChange={(e) => handleEnrollmentChange(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // Prevent page refresh
                        onENRNoBlur(); // Trigger search
                      }
                    }}
                    required
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
          )}
          <Modal.Footer className="d-flex flex-column">
            <Button
              type="submit"
              style={{ backgroundColor: "#3f41d1" }}
              className="w-100"
              onClick={onENRNoBlur}
              disabled={loading}
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Continue"}
            </Button>

            <div className="w-100 position-relative text-center my-3">
              <hr />
              <span
                className="position-absolute bg-white px-3"
                style={{
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "#6c757d",
                  fontWeight: "bold",
                }}
              >
                OR
              </span>
            </div>

            <Button
              variant="secondary"
              className="w-100"
              onClick={handleNonVibgyor}
              disabled={loading}
            >
              Non-Vibgyor Student
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {infoModal && (
        <>
          <Modal
            show={infoModal}
            onHide={() => setInfoModal(false)}
            centered
            backdrop="static"
          >
            <Modal.Header>
              <Modal.Title>Important Information</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              <div className="d-flex justify-content-center">
                <div
                  style={{
                    width: "55px",
                    height: "55px",
                    backgroundColor: "#3F41D1",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <div
                    style={{
                      color: "white",
                      fontSize: "40px",
                      fontWeight: "bold",
                    }}
                  >
                    !
                  </div>
                </div>
              </div>
              <p className="mb-4">
                Please select your school venue and grade using the filter
                option to view relevant details.
              </p>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
              <Button
                style={{ backgroundColor: "#3f41d1" }}
                onClick={highlightFilter}
              >
                I Understand
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </div>
  );
};

export default ListingPsaArea;
